import {createMeasurement} from "../api/createMeasurement";
import {convertStringNumbers} from "../model/convertStringNumbers";
import {ADD_MEASURE_MODAL_CONTENTS} from "../components/AddMeasureModalContent";

export const useAddMeasure = ({ lineUserId, selectedMetric, measurement, measureDateTime, setModalContent }) => {
  const submit = async () => {
    // check guest available
    try {
      // add measurement
      const data = {
        lineId: lineUserId,
        type: selectedMetric,
        measurement: convertStringNumbers(measurement as Record<string, unknown>),
        measureDateTime: measureDateTime.toDate(),
      }
      await createMeasurement(data)
    } catch (e) {
      console.log(e)
    } finally {
      setModalContent(ADD_MEASURE_MODAL_CONTENTS.ADDED);
    }
  }

  return { submit }
}